module.exports = __webpack_public_path__ + "static/media/picto-red-fixed.859b7921.png";